<app-expansion-panel title="Ask Your Question">

  <ng-template #chatForm>
    <app-chat-form (onSubmit)="submitQuestion($event)"
    [isLoading]="(isLoading$ | async) ?? false"
    [error]="isError.value"></app-chat-form>
  </ng-template>

  <ng-container *ngIf="(isReply | async); else chatForm">
    <app-chat-reply
      [reply]="fullMessageText | async"
      [videoAnswerText]="videoAnswerText.value"
      [resources]="resources.value"
      [videoResources]="videoResources.value"
      (onClick)="clearReply()"
      [message]="message"
      [safetyText]="safetyText.value"
      [transactionId]="transactionId"
      [showGeneralAIFallback]="(showGeneralAIButton | async) ?? false"
      [genericReply]="genericReplyText | async"
      [safetyGenericText]="safetyGenericText.value"
      [isGenericLoading]="(isGenericLoading | async) ?? false"
      (onTryGeneralAI)="handleTryGeneralAI()">
    </app-chat-reply>
  </ng-container>
</app-expansion-panel>
